import { AxiosInstance } from './auth/AxiosInstance';

export const submitContactForm = async (formData) => {
  try {
    const response = await AxiosInstance.post('/contact/submit', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to send message' };
  }
};
